import { News, NewsService } from "./types"
import { FrontendConfig } from "../../../FrontendConfig/types"
import { IHttpService } from "@cirrus/core/http/types"

export class NewsServiceHttp implements NewsService {
  private customer: FrontendConfig["Customer"] | null = null
  private http: IHttpService | null = null

  getNews = async () => {
    if (!this.customer) throw new Error("Customer not found")
    return this.http?.get<any>(`/api/v1/customer/${this.customer}/news`)
  }

  constructor(customer: FrontendConfig["Customer"], http: IHttpService) {
    this.customer = customer
    this.http = http
  }
}

export class Mock implements NewsService {
  private news: News | null = null
  
  constructor(news?: News) {
    news && (this.news = news)
  }
  
  getNews = async () => ({ data: this.news })
}
